import { Observable, observe, Scope } from 'wdc-cube'
import { WaitingScope } from '../../the-connection/tc_scopes'
import { GroupRow } from '../group-manager/gm_scopes'

export enum ExportLimitReference {
    USER = 'USER',
    GROUP = 'GROUP'
}

export type UserRow = {
    id?: number
    name: string
    password: string
    full_name: string
    position?: string
    fone?: string
    compliant: boolean
    the_connection: boolean
    tc_companies: boolean
    tc_partners: boolean
    tc_doctors: boolean
    tc_relationships: boolean
    the_map: boolean
    analise_desempenho: boolean
    the_acting: boolean
    the_acting_print: boolean
    the_consumer_market: boolean
    the_consumer_market_ia: boolean
    tcm_companies: boolean
    tcm_partners: boolean
    tcm_doctors: boolean
    tcm_relationships: boolean
    tcm_enchente_rs_24: boolean
    mercado_vet: boolean
    user_manager: boolean
    admin_gestao: boolean
    acesso_auditoria: boolean
    acesso_faturamento: boolean
    motor_credito: boolean
    mc_admin: boolean
    mc_system_id?: number
    mc_pj: boolean
    mc_pf: boolean
    mc_serasa: boolean
    mc_serasa_history: boolean
    mc_serpro: boolean
    mc_grupo: boolean
    mc_analise: boolean
    mc_bordero: boolean
    mc_monitoramento: boolean
    can_export_data: boolean
    export_limit_reference?: ExportLimitReference
    preferred_group_id?: number
    preferred_group_name?: string
    limit_export_quantity?: number
    groups?: GroupRow[]
    sendWelcomeMail: boolean
    deleted_date?: Date
    active: boolean
    unlimited_data_export: boolean
    tcm_filtro_cnpj_modo_clonagem: boolean
}

export type UserChangePasswordRequestData = {
    password: string
    passwordConfirmation: string
    sendToEmail: boolean
}

export type SimpleGroup = {
    id: number
    admin_id: number
    name: string
    active: boolean
}

export type SimpleUserWithGroups = {
    id: number
    name: string
    full_name?: string
    active: boolean
    groups?: SimpleGroup[]
}

export type NotificationType = {
    id: number
    name: string
    active: boolean
}

@Observable
export class HeaderScope extends Scope {}

@Observable
export class UserManagerScope extends Scope {
    readonly header = new HeaderScope()

    @observe() waiting?: WaitingScope
    @observe() userFilter = ''

    @observe() users = [] as UserRow[]

    @observe() showDeleted = false
    @observe() deleteModalOpen = false
    @observe() userToDelete?: UserRow
    @observe() deleteConfirmText = ''

    onShowDeletedChange = Scope.ASYNC_ACTION
    onDelete = Scope.ASYNC_ACTION_NUMBER
    onDeleteConfirmTextChanged = Scope.ASYNC_ACTION_STRING
    onConfirmDelete = Scope.ASYNC_ACTION
    onCancelConfirmDelete = Scope.ASYNC_ACTION

    onNew = Scope.ASYNC_ACTION
    onEdit = Scope.ASYNC_ACTION_NUMBER
    onFind = Scope.ASYNC_ACTION_STRING
}

export default UserManagerScope
